import React from 'react';

/**
 * A member's face: their colour plus a bundled emoji avatar (an image, so it
 * looks the same on every phone). Shared across verticals — a household member,
 * a guest or a resident all render through this.
 */
export const MemberAvatar = ({ member, size = 32, ring = false, testId }) => {
    if (!member) return null;
    const px = `${size}px`;
    return (
        <span
            className={`relative inline-flex shrink-0 items-center justify-center rounded-full ${ring ? 'ring-2 ring-offset-2 ring-offset-white dark:ring-offset-slate-900' : ''}`}
            style={{ width: px, height: px, background: `${member.avatar_color || '#64748b'}22`, borderColor: member.avatar_color, ringColor: member.avatar_color }}
            data-testid={testId || `member-avatar-${member.id}`}
            title={member.name}
        >
            <span className="absolute inset-0 rounded-full border-2" style={{ borderColor: member.avatar_color || '#64748b' }} />
            {member.avatar_icon ? (
                <img src={member.avatar_icon} alt="" aria-hidden="true" width={size * 0.62} height={size * 0.62}
                    className="object-contain" draggable={false} data-member-avatar={member.id} />
            ) : (
                <span className="text-sm font-bold" style={{ color: member.avatar_color }}>
                    {(member.name || '?').slice(0, 1).toUpperCase()}
                </span>
            )}
        </span>
    );
};

export default MemberAvatar;
